import { MagneticButton } from '@/components/motion/MagneticButton'
import { Reveal } from '@/components/motion/Reveal'
import { TiltCard } from '@/components/motion/TiltCard'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { ServiceIcon } from '@/components/ui/ServiceIcon'
import { FEATURED_SERVICE_IDS, SERVICE_IDS } from '@/content/services'
import { useTranslations } from '@/app/site-context'

export function Services() {
  const { services, hero, contact } = useTranslations()

  return (
    <section className="services section" id="services" aria-labelledby="services-title">
      <SectionHeading title={services.title} id="services-title" lede={services.lede} index="02" />
      <ul className="services__grid">
        {SERVICE_IDS.map((id, index) => {
          const item = services.items[id]
          const featured = FEATURED_SERVICE_IDS.includes(id)
          return (
            <li key={id} className={featured ? 'services__item--featured' : undefined}>
              <Reveal variant="scale" delay={Math.min(index, 8) * 45}>
                <TiltCard
                  className={
                    featured ? 'services__card services__card--featured' : 'services__card'
                  }
                  intensity={featured ? 5 : 8}
                >
                  <span
                    className="services__index"
                    data-index={String(index + 1).padStart(2, '0')}
                    aria-hidden="true"
                  />
                  <span className="services__icon">
                    <ServiceIcon id={id} size={featured ? 44 : 34} />
                  </span>
                  <h3 className="services__title">{item.title}</h3>
                  <p className="services__body">{item.body}</p>
                </TiltCard>
              </Reveal>
            </li>
          )
        })}
      </ul>

      <Reveal variant="rise" className="services__cta">
        <p className="services__cta-text">{contact.lede}</p>
        <MagneticButton href="#contact" className="button button--solid" strength={0.25}>
          {hero.ctaPrimary}
          <span className="button__arrow" aria-hidden="true">
            →
          </span>
        </MagneticButton>
      </Reveal>
    </section>
  )
}
